export enum MapTypes {
    Roadmap = 'roadmap',
    Satellite = 'satellite',
    Hybrid = 'hybrid'
}
